import { EventData, EventListener } from '../event/index.js';
class SwapEvent extends EventData {
    constructor() {
        super();
    }
}
class SwapEventListener extends EventListener {
    constructor() {
        super(SwapEvent);
    }
}
export { SwapEvent, SwapEventListener, };
//# sourceMappingURL=swappable.js.map